import { Box } from "@chakra-ui/react";
const Feed = () => {
	return (
		<Box></Box>
	);
};

export default Feed;